import IdentifyApi from '@apis/auth/IdentifyApi';
import { IdentifyRequest } from '@models/identify';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

// 본인인증 페이지 호출
function useIdentification() {
    const { t } = useTranslation('signUp');

    return (request: IdentifyRequest) => {
        IdentifyApi.identify(request)
            .then((res) => {
                const form = document.createElement('form');
                form.hidden = true;
                form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
                const mInput = document.createElement('input');
                mInput.name = 'm';
                mInput.value = 'checkplusService';
                const dataInput = document.createElement('input');
                dataInput.name = 'EncodeData';
                dataInput.value = res.encryptedData;
                form.append(mInput);
                form.append(dataInput);
                document.body.appendChild(form);
                form.submit();
            }).catch((e) => {
                console.error('본인인증 오류', e);
                toast.error(t('toast.identifyFailed'));
            });
    };
}

export default useIdentification;
